@if (workspacesCount <= 0) {
  <div>Unauthorised to manage any workspace</div>
}
<router-outlet></router-outlet>
